import * as d3 from 'd3'
export default {
  methods: {

    draw_Legends() {

      this.count_Area()
      this.count_ITRs()
      
      this.canvasLegend = this.svg
      .append('g')
      .attr('id', 'LEGEND_CANVAS')
      .attr('transform', `translate(${this.legend.x}, ${this.legend.y})`)
      .attr('font-family', 'roboto')

      let legendArea = this.canvasLegend
      .append('g')
      .attr('transform', `translate(0, 10)`)

      legendArea
      .append('text')
      .attr('transform', `translate(0, 4)`)
      .style('font-size', 13).style('fill', '#000')
      .text(`UNIT`)
      this.legend_Area(legendArea) // -----> below


      let legendSheet = this.canvasLegend
      .append('g')
      .attr('transform', `translate(0.5, 80.5)`)

      legendSheet
      .append('text')
      .attr('transform', `translate(0, -35)`)
      .style('font-size', 13).style('fill', '#000')
      .text(`Legends`)

      legendSheet
      .append('text')
      .attr('transform', `translate(10, -15)`)
      .style('font-size', 12).style('fill', '#44A9DF')
      .text(`A ITRs Status`)
      this.legend_ITRs(legendSheet) // -----> below
    },


    legend_Area(selection) {

      let x = 60
      this.area.forEach(d=> {
        
        let area = selection
        .append('g')
        .attr('id', `AREA_${d.code}`)
        .attr('transform', `translate(${parseInt(x)}, 0)`)
        .attr('opacity', this.current.area == d.code ? 1 : 0.8)
        .attr('cursor', 'pointer')
        .on('mouseover', () => { 
          d3.select(`#AREA_${d.code}`).attr('opacity', this.current.area == d.code ? 1 : 0.6) 
        })
        .on('mouseout', () => { 
          d3.select(`#AREA_${d.code}`).attr('opacity', this.current.area == d.code ? 1 : 0.8) 
        })
        .on('click', ()=> {
          if(this.current.area == d.code) return
          d3.select(`#AREA_${this.current.area}`).transition().duration(300).attr('opacity', .8) 
          d3.select(`#AREA_TXT_${this.current.area}`).transition().duration(300).attr('font-weight', 400).attr('fill', '#333')
          d3.select(`#AREA_IN_${this.current.area}`).transition().duration(300).attr('opacity', 0)
  
          this.current.area = d.code
          d3.select(`#AREA_${d.code}`).transition().duration(150).attr('opacity', 1) 
          d3.select(`#AREA_TXT_${d.code}`).transition().duration(150).attr('font-weight', 450).attr('fill', '#000')
          d3.select(`#AREA_IN_${d.code}`).transition().duration(150).attr('opacity', 1)
          
          this.count_ITRs(this.rawData)
          this.reflash_Skyline()
          this.set_selectedItems() // -----> PDF.js
        })
        
        area
        .append('circle')
        .attr('id', `AREA_OUT_${d.code}`)
        .attr('transform', `translate(0, -0.5)`)
        .attr('r', 6).attr('stroke', '#F7BACF').attr('stroke-width', 1).attr('fill', '#fff')

        area
        .append('circle')
        .attr('id', `AREA_IN_${d.code}`)
        .attr('transform', `translate(0,-0.5)`)
        .attr('r', 3).attr('stroke', '#F35E90')
        .attr('stroke-width', 0).attr('fill', '#F35E90').attr('opacity', this.current.area == d.code ? 1 : 0)

        area
        .append('text')
        .attr('id', `AREA_TXT_${d.code}`)
        .attr('transform', `translate(11, 3.5)`)
        .attr('font-size', 11).attr('fill', '#000')
        .attr('font-weight', this.current.area == d.code ? 450 : 400)
        .attr('text-anchor', 'start')
        .text(`${d.name} (${d.count})`)

        x += this.getNode(`#AREA_TXT_${d.code}`, 'width') + 40
      })
    },


    legend_ITRs(selection) {

      let x = 20
      this.sheet.forEach(d=> {

        let legendSheet = selection
        .append('g')
        .attr('id', `ITR${d.code}`)
        .attr('transform', `translate(${parseInt(x)}, 0)`)
        .attr('opacity', this.current.sheet == d.code ? 1 : 0.8)
        .style('cursor', 'pointer')
        .on('mouseover', () => { 
          d3.select(`#ITR${d.code}`).attr('opacity', this.current.sheet == d.code ? 1 : 0.5) 
        })
        .on('mouseout', () => { 
          d3.select(`#ITR${d.code}`).attr('opacity', this.current.sheet == d.code ? 1 : 0.8) 
        })
        .on('click', ()=> {
          d3.select(`#ITR${this.current.sheet}`).attr('opacity', 0.8)
          d3.select(`#SHT_TXT_${this.current.sheet}`).attr('font-weight', 400).attr('fill', '#757575')

          this.current.sheet = d.code
          d3.select(`#ITR${d.code}`).style('opacity', 1)
          d3.select(`#SHT_TXT_${d.code}`).attr('font-weight', 600).attr('fill', '#000')
          
          this.reflash_Skyline()
          this.set_selectedItems() // -----> PDF.js 

          let line = this.sheet.find(f=> f.code == this.current.sheet)
          d3.select(`#ITR_LINE`).transition().duration(200).attr('x1', line.x-6).attr('x2', line.x + line.width - 6)
        })
        
        legendSheet
        .append('rect')
        .attr('x', -5).attr('y', -6)
        .attr('rx', 2).attr('ry', 2)
        .attr('width', 12).style('height', 12)
        .attr('stroke', d.stroke).attr('stroke-width', d.sWidth).attr('fill', d.color)

        legendSheet
        .append('text')
        .attr('id', `SHT_TXT_${d.code}`)
        .attr('transform', `translate(11, 3)`)
        .attr('font-size', 10).attr('fill', '#000')
        .attr('font-weight', this.current.sheet == d.code ? 600 : 400)
        .attr('text-anchor', 'start')
        .text(`${d.name} (${d.count})`)
        d.x = x
        d.width = this.getNode(`#ITR${d.code}`, 'width')
        x += this.getNode(`#ITR${d.code}`, 'width') + 20
      })

      let line = this.sheet.find(f=> f.code == this.current.sheet)
      selection
      .append('line')
      .attr('id', `ITR_LINE`)
      .attr('x1', line.x-6).attr('x2', line.x + line.width - 6).attr('y1', 10).attr('y2', 10)
      .attr('stroke', '#44A9DF').attr('stroke-width', .5)
    },
    
  }
}